module.exports = __webpack_public_path__ + "static/media/Tarots_01_All-41.c710985b.svg";